import { ClockAlertIcon } from 'lucide-react'
import type { CondicaoUi } from './condicao-ui'

export const marcacaoFaltando: CondicaoUi = {
    icone: ClockAlertIcon,
    parametrosIniciais: {},
}
